import { c as _c } from "react/compiler-runtime";
import { Button, CloseButton, Dialog, Portal, Text, Textarea, VStack } from '@chakra-ui/react';
import { Field } from '@src/components/chakra-ui/field';
import { useEffect, useState } from 'react';
export const SESSION_REVIEW_REPORT_REASON_MAX_LENGTH = 1000;
export type SessionReviewReportDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Resolves when the report is saved; reject to show the error in the dialog. */
  onSubmit: (reason: string) => Promise<void>;
  submitting?: boolean;
  error?: string | null;
};

/** Report a review to ops (L40). The reason goes to ops only; the review stays until ops acts. */
export const SessionReviewReportDialog = t0 => {
  const $ = _c(37);
  const {
    open,
    onOpenChange,
    onSubmit,
    submitting: t1,
    error: t2
  } = t0;
  const submitting = t1 === undefined ? false : t1;
  const error = t2 === undefined ? null : t2;
  const [reason, setReason] = useState("");
  const [localError, setLocalError] = useState(null);
  let t3;
  let t4;
  if ($[0] !== open) {
    t3 = () => {
      if (open) {
        setReason("");
        setLocalError(null);
      }
    };
    t4 = [open];
    $[0] = open;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] !== onSubmit || $[4] !== reason) {
    t5 = async () => {
      if (!reason.trim()) {
        setLocalError("Tell us what is wrong with this review.");
        return;
      }
      setLocalError(null);
      await onSubmit(reason.trim());
    };
    $[3] = onSubmit;
    $[4] = reason;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleSubmit = t5;
  const shownError = localError || error;
  let t6;
  if ($[6] !== onOpenChange) {
    t6 = event => onOpenChange(event.open);
    $[6] = onOpenChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Dialog.Backdrop />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Dialog.Title>Report this review</Dialog.Title>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Dialog.Header>{t8}<Dialog.CloseTrigger asChild={true} insetEnd={3} position="absolute" top={3}><CloseButton size="sm" /></Dialog.CloseTrigger></Dialog.Header>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Text color="fg.muted" fontSize="sm">Only the Startups team sees your report. The review stays on your profile until we look at it. You can hide it yourself in the meantime.</Text>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = event_0 => setReason(event_0.target.value);
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== reason) {
    t12 = <Field label="What is wrong with it?"><Textarea maxLength={SESSION_REVIEW_REPORT_REASON_MAX_LENGTH} placeholder="For example: this person never had a session with me." rows={4} value={reason} onChange={t11} /></Field>;
    $[13] = reason;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== shownError) {
    t13 = shownError && <Text color="red.fg" fontSize="sm" role="alert">{shownError}</Text>;
    $[15] = shownError;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12 || $[18] !== t13) {
    t14 = <Dialog.Body><VStack align="stretch" gap={3}>{t10}{t12}{t13}</VStack></Dialog.Body>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== onOpenChange) {
    t15 = <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>;
    $[20] = onOpenChange;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== handleSubmit) {
    t16 = () => void handleSubmit();
    $[22] = handleSubmit;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== submitting || $[25] !== t16) {
    t17 = <Button loading={submitting} variant="cta" onClick={t16}>Send report</Button>;
    $[24] = submitting;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t15 || $[28] !== t17) {
    t18 = <Dialog.Footer gap={2}>{t15}{t17}</Dialog.Footer>;
    $[27] = t15;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t14 || $[31] !== t18) {
    t19 = <Portal>{t7}<Dialog.Positioner paddingX={4}><Dialog.Content maxWidth="480px" width="full">{t9}{t14}{t18}</Dialog.Content></Dialog.Positioner></Portal>;
    $[30] = t14;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== open || $[34] !== t19 || $[35] !== t6) {
    t20 = <Dialog.Root motionPreset="scale" open={open} placement="center" size="md" onOpenChange={t6}>{t19}</Dialog.Root>;
    $[33] = open;
    $[34] = t19;
    $[35] = t6;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
};